import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

import { AchBoStatus } from "../../definitions/api/consumer-log/ach-bo-status";
import { AchDocument } from "../../definitions/api/consumer-log/ach-document";
import { AppConfigService } from "../app.config.service";
import { ApiService } from "./api.service";
import { BaseApiService } from "./base-api.service";

@Injectable({ providedIn: "root" })
export class ConsumerLogService extends BaseApiService {
	constructor(
		private api: ApiService,
		appConfigService: AppConfigService
	) {
		super("mpapi/consumer-log", appConfigService.getConfigValue("API_ENDPOINT"));
	}

	achAccountStatus(): Observable<string> {
		return this.api
			.get<{ status: string }>(this.url("/get-status"), "errors.get-ach-account-status-failed")
			.pipe(map((res) => res.status));
	}

	achAccountDocuments(): Observable<AchDocument[]> {
		return this.api.get<AchDocument[]>(this.url("/get-required-documents"));
	}

	achBeneficialOwnerStatus(): Observable<AchBoStatus[]> {
		return this.api.get<AchBoStatus[]>(this.url("/get-beneficial-owner-status"));
	}
}
